import { PaymentFormProps, PaymentMethod } from "../../../../types"
import paymentMethodValidator from "./paymentMethodValidator"
import React, { FC, useEffect, useState } from "react"
import { connect } from "react-redux"
import { createPaymentMethod, deletePaymentMethod, updatePaymentMethod } from "../../../../actions"
import { KButton, KDropdown, KInput, KTitleSpan } from "kahuna-base-react-components"
import Warning from "./Warning"
import { lang } from "../../../../constants/languages"
import { currencyOptions, ibanLengths } from "../../../../constants"
import { KSelectOption } from "kahuna-base-react-components/dist/components/KDropdown/KDropdown"

const PaymentForm: FC<PaymentFormProps> = (props) => {
  const {
    initialValues,
    editable,
    deletePaymentMethod,
    updatePaymentMethod,
    createPaymentMethod,
    setAdding,
    edit,
    setEdit,
    adminPanelUserId,
    title,
    addPaymentMethod,
    setAddPaymentMethod,
    chosenMethod
  } = props

  const [paymentMethod, setPaymentMethod] = useState<PaymentMethod>(
    chosenMethod || {
      bankName: "",
      iban: "",
      accountHolderName: "",
      swiftCode: "",
      currency: ""
    }
  )

  const formatIban = (rawValue: string) => {
    if (rawValue === "") {
      setPaymentMethod({ ...paymentMethod, iban: "" })
      return
    }

    const regex = /^[A-Za-z0-9\s]*$/
    if (!regex.test(rawValue)) return

    const cleaned = rawValue.replace(/\s+/g, "").toUpperCase()

    const formattedIban = cleaned.replace(/(.{4})/g, "$1 ").trim()

    setPaymentMethod({
      ...paymentMethod,
      iban: formattedIban
    })
  }

  return (
    <>
      <div className="pt-8 pb-4 px-6 w-[440px] shadow-md rounded-[10px] bg-[#fff]">
        <div className="flex flex-col items-center gap-8">
          <div className="flex flex-col gap-8 items-center">
            <span
              style={{
                padding: 16,
                borderRadius: "9999px",
                background: "var(--bg-white-0, #FFF)",
                boxShadow:
                  "0px 32px 24px -12px rgba(17, 17, 17, 0.06), 0px 11px 4px 0px rgba(17, 17, 17, 0.01), 0px 6px 4px 0px rgba(17, 17, 17, 0.02), 0px 3px 3px 0px rgba(17, 17, 17, 0.03), 0px 1px 1px 0px rgba(17, 17, 17, 0.04), 0px 0px 0px 1px rgba(17, 17, 17, 0.04)"
              }}
            >
              <img className="w-8 h-8" src="/account_icons/wallet-filled.svg" />
            </span>
            <KTitleSpan text={title || ""} fontSize={24} lineHeight="28px" color="#000" />
          </div>
          <div className="flex flex-col gap-4 items-center w-full ">
            <KInput
              dataTestId="payment-method-title"
              value={paymentMethod.bankName}
              placeholder={lang.account.payment_methods.payment_form.title_placeholder}
              padding="14px"
              onChange={(value) => {
                setPaymentMethod({ ...paymentMethod, bankName: value })
              }}
            />
            <KInput
              dataTestId="payment-method-iban"
              value={paymentMethod.iban}
              placeholder="IBAN (TR52 xxxx xxxx)"
              padding="14px"
              onChange={(value) => {
                formatIban(value)
              }}
            />
            <KInput
              dataTestId="payment-method-account-holder-name"
              value={paymentMethod.accountHolderName}
              placeholder={lang.account.payment_methods.payment_form.account_holder_name_placeholder}
              padding="14px"
              onChange={(value) => {
                setPaymentMethod({ ...paymentMethod, accountHolderName: value })
              }}
            />
            <div className="flex gap-2" style={{ width: "100%" }}>
              <div style={{ width: "50%" }}>
                <KInput
                  dataTestId="payment-method-swift-code"
                  value={paymentMethod.swiftCode || ""}
                  placeholder={lang.account.payment_methods.payment_form.switf_bic_code_placeholder}
                  padding="14px"
                  onChange={(value) => {
                    setPaymentMethod({ ...paymentMethod, swiftCode: value })
                  }}
                />
              </div>
              <div style={{ width: "50%" }}>
                <KDropdown
                  dataTestId="payment-method-currency"
                  height={47}
                  placeholder={lang.account.payment_methods.payment_form.currency}
                  options={currencyOptions}
                  onSelect={(selected) =>
                    setPaymentMethod({ ...paymentMethod, currency: (selected as KSelectOption)?.value2 })
                  }
                  selected={currencyOptions.find((option) => option.value2 === paymentMethod.currency)}
                />
              </div>
            </div>
            <Warning warning={lang.account.payment_methods.payment_form.warning_text} />
            <div className="flex mt-8 gap-3" style={{ width: "100%" }}>
              <KButton
                dataTestId="payment-method-cancel"
                text={lang.common.cancel}
                height="48px"
                onClick={() => {
                  if (edit === undefined && addPaymentMethod !== undefined && setAddPaymentMethod !== undefined) {
                    setAddPaymentMethod(false)
                  } else if (edit !== undefined && setEdit !== undefined && addPaymentMethod === undefined) {
                    setEdit(false)
                  }
                }}
                shadowDisabled={true}
                background="#fff"
                textColor="#000"
              />
              <KButton
                dataTestId="payment-method-accept"
                background="#000"
                textColor="#FFF"
                height="48px"
                text={lang.common.accept}
                onClick={() => {
                  const errors = paymentMethodValidator(paymentMethod) // checks if there is any mistake about given values
                  //localStorage.setItem("paymentMethod", JSON.stringify(paymentmethod))
                  if (edit === undefined && addPaymentMethod !== undefined && setAddPaymentMethod !== undefined) {
                    if (Object.keys(errors).length === 0) {
                      setAddPaymentMethod(false)
                      if (paymentMethod.swiftCode === "") {
                        delete paymentMethod.swiftCode
                        createPaymentMethod(paymentMethod, adminPanelUserId)
                      } else {
                        createPaymentMethod(paymentMethod, adminPanelUserId)
                      }
                    }
                  } else if (edit !== undefined && setEdit !== undefined && addPaymentMethod === undefined) {
                    if (Object.keys(errors).length === 0) {
                      setEdit(false)
                      if (paymentMethod.swiftCode === "") {
                        delete paymentMethod.swiftCode
                        updatePaymentMethod(paymentMethod)
                      } else {
                        updatePaymentMethod(paymentMethod)
                      }
                    }
                  }
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default connect(null, { createPaymentMethod, deletePaymentMethod, updatePaymentMethod })(PaymentForm)
